module.exports = "pegasus/assets/email1-testi-img.png";